import * as React from 'react';
import { SampleBase } from '../../syncfusion/sample-base';
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from '@syncfusion/ej2-react-layouts';
import { ComboBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { /* config, */number_format,handleResponse } from '../../_helpers'
import { authenticationService } from '../../_services'
import { MapAjax } from '@syncfusion/ej2-maps';
import { MapsComponent, LayersDirective, LayerDirective, MarkersDirective, MarkerDirective, Marker, Legend as MapsLegend, MapsTooltip } from '@syncfusion/ej2-react-maps';
import './dashBoard.css';
import * as data from './default-datasource.json';
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, Legend, PieSeries, AccumulationTooltip, SeriesCollectionDirective, AccumulationDataLabel, ChartComponent, ColumnSeries, Category, SeriesDirective, Tooltip, DataLabel, DateTime, SplineAreaSeries, Inject } from '@syncfusion/ej2-react-charts';

let g_ind_cosecha;
//let pivotDataSettings = pivotSettings;
let v_total;
//let g_data =datadash;
//let g_data = consultar(config.HostUrl + "analisis/resumen?cosecha=1",authenticationService.currentUserValue.jwt_token);


export let expensedata = [
    {
        'UniqueId': 'T100003',
        'DateTime': new Date(1488359820000),
        'Category': 'Food',
        'PaymentMode': 'Cash',
        'TransactionType': 'Expense',
        'Description': 'Confederate cush',
        'Amount': '900',
        'MonthShort': 'Mar',
        'MonthFull': 'March, 2017',
        'FormattedDate': '03/01/2017 08:53 PM',
        'Device': 'Tablet',
        'text':'33.3%'
    }, {
        'UniqueId': 'T100004',
        'DateTime': new Date(1491038220000),
        'Category': 'Transportation',
        'PaymentMode': 'Credit Card',
        'TransactionType': 'Expense',
        'Description': 'Public and other transportation',
        'Amount': '1200',
        'MonthShort': 'Apr',
        'MonthFull': 'April, 2017',
        'FormattedDate': '04/01/2017 10:44 AM',
        'Device': 'Desktop',
        'text':'44.5%'
    }, {
        'UniqueId': 'T100005',
        'DateTime': new Date(1493630220000),
        'Category': 'Transportation',
        'PaymentMode': 'Cash',
        'TransactionType': 'Expense',
        'Description': 'Public and other transportation',
        'Amount': '600',
        'MonthShort': 'May',
        'MonthFull': 'May, 2017',
        'FormattedDate': '05/01/2017 03:25 PM',
        'Device': 'Mobile',
        'text':'22.2%'
    },
];
export let data1 = [
    { x: new Date(2002, 0, 1), y: 2.2 }, { x: new Date(2003, 0, 1), y: 3.4 },
    { x: new Date(2004, 0, 1), y: 2.8 }, { x: new Date(2005, 0, 1), y: 1.6 },
    { x: new Date(2006, 0, 1), y: 2.3 }, { x: new Date(2007, 0, 1), y: 2.5 },
    { x: new Date(2008, 0, 1), y: 2.9 }, { x: new Date(2009, 0, 1), y: 3.8 },
    { x: new Date(2010, 0, 1), y: 1.4 }, { x: new Date(2011, 0, 1), y: 3.1 }
];
export let data2 = [
    { x: new Date(2002, 0, 1), y: 2 }, { x: new Date(2003, 0, 1), y: 1.7 },
    { x: new Date(2004, 0, 1), y: 1.8 }, { x: new Date(2005, 0, 1), y: 2.1 },
    { x: new Date(2006, 0, 1), y: 2.3 }, { x: new Date(2007, 0, 1), y: 1.7 },
    { x: new Date(2008, 0, 1), y: 1.5 }, { x: new Date(2009, 0, 1), y: 2.8 },
    { x: new Date(2010, 0, 1), y: 1.5 }, { x: new Date(2011, 0, 1), y: 2.3 }
];

let datasource = data;
//let dataSourceDash;
let markers = [
    { name: 'Asia', latitude: 50.32087157990324, longitude: 90.015625 },
    { name: 'Australia', latitude: -25.88583769986199, longitude: 134.296875 },
    { name: 'Africa', latitude: 16.97274101999902, longitude: 16.390625 },
    { name: 'Europe', latitude: 49.95121990866204, longitude: 18.468749999999998 },
    { name: 'North America', latitude: 59.88893689676585, longitude: -109.3359375 },
    { name: 'South America', latitude: -6.64607562172573, longitude: -55.54687499999999 }
];


export class SEODashboard extends SampleBase {
    constructor() {
        super(...arguments);
        this.cellSpacing = [5, 5];
        this.state = {
            data : null,
            loading : true
        };
        //debugger;
        this.CfgOptions = authenticationService.currentUserValue.usuario.configuracion.replace(/'/g,"\"");
        this.CfgOptions = this.CfgOptions.replace(/: False/g,": false");
        this.CfgOptions = this.CfgOptions.replace(/: True/g,": true");
        this.CfgOptions = JSON.parse(this.CfgOptions).dashboard[authenticationService.currentUserValue.usuario.idioma];
        /* this.maestroCosecha = [{id_cosecha:1, cosecha:'Cosecha201901', id_agricultor:2, id_cultivo:1},
                                {id_cosecha:2, cosecha:'Cosecha202001', id_agricultor:2, id_cultivo:1}] */
        this.maestroCosecha = new DataManager({
                                    /* url: config.HostUrl + "queries/cosecha", */
                                    url: JSON.parse(sessionStorage.config).HostUrl + this.CfgOptions[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.CfgOptions[this.props.opcion].endpointcosecha,
                                    adaptor: new WebApiAdaptor(),
                                    headers:[{ "Content-Type":  "application / json",
                                                "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                            }],
                                    crossDomain: true
                                });
        // maps the appropriate column to fields property
        this.fields = { text: 'cosecha', value: 'id_cosecha' };
        // set the value to select an item based on mapped value at initial rendering
        this.value = 'Cosecha2021901';
        
    }

    onChange() {
        //debugger;
        this.value = this.listObj.text;
        const l_url = JSON.parse(sessionStorage.config).HostUrl + this.CfgOptions[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.CfgOptions[this.props.opcion].endpoint + "?cosecha=" + this.listObj.value;
        this.setState({ data : null, loading : true });
        this.data = this.consultar(l_url,authenticationService.currentUserValue.jwt_token);
    }

    // call the change event's function after initialized the component.
    rendereComplete() {
 
    }
   /*  consulta_cosecha(datos, cosecha) {
        let itemMod;

        datos.map(function (item) {
            if (item.id_cosecha = cosecha) {
                itemMod = { bultos_cargados:item.bultos_cargados,
                            cards:[ {name:'Bultos Cosechados',value:item.bultos_cosechados},
                                    {name:'Bultos Cosechados en Lotes Terminados',value:item.bultos_cosechados_lotes_terminados},
                                    {name:'Bultos Cargados',value:item.bultos_cargados},
                                    {name:'Bultos Cargados en lotes terminados',value:item.bultos_cargados_lotes_terminados},
                                    {name:'Número recepciones',value:item.num_recepciones},
                                    {name:'Número recepciones en lotes terminados',value:item.num_recepciones_lotes_terminados},
                                    {name:'Número de Cargas',value:item.num_cargas},
                                    {name:'Número de Cargas en lotes terminados',value:item.num_cargas_lotes_terminados},
                                    {name:'Número de Vehiculos',value:item.num_vehiculos},
                                    {name:'Número de Vehiculos en lotes terminados',value:item.num_vehiculos_lotes_terminados}],
                            bigcards:[{name:'Bultos xHa',value:item.bultos_cosechados_lotes_terminados/item.area_terminada}],
                            area:[{tipo:'Cosechada',cantidad:item.area_terminada,porcentaje:(item.area_terminada/item.area_total)*100},{tipo:'Sin cosechar',cantidad:item.area_total-item.area_terminada,porcentaje:((item.area_total-item.area_terminada)/item.area_total)*100}],
                            lotes:[{tipo:'Cosechados',cantidad:item.num_lotes,porcentaje:(item.nume_lotes_terminados/item.num_lotes)*100},{tipo:'Sin cosechar',cantidad:item.num_lotes-item.num_lotes_terminados,porcentaje:((item.num_lotes-item.num_lotes_terminados)/item.num_lotes)*100}]};

            }
            
        });

        return itemMod;
    } */

    consulta_cosechas(item, cosecha) {
        let itemMod;

        itemMod = { bultos_cargados:item.bultos_cargados,
                            cards:[ {name:'Bultos Cosechados',value:item.bultos_cosechados},
                                    {name:'Bultos Cosechados en Lotes Terminados',value:item.bultos_cosechados_lotes_terminados},
                                    {name:'Bultos Cargados',value:item.bultos_cargados},
                                    {name:'Bultos Cargados en lotes terminados',value:item.bultos_cargados_lotes_terminados},
                                    {name:'Número recepciones',value:item.num_recepciones},
                                    {name:'Número recepciones en lotes terminados',value:item.num_recepciones_lotes_terminados},
                                    {name:'Número de Cargas',value:item.num_cargas},
                                    {name:'Número de Cargas en lotes terminados',value:item.num_cargas_lotes_terminados},
                                    {name:'Número de Vehiculos',value:item.num_vehiculos},
                                    {name:'Número de Vehiculos en lotes terminados',value:item.num_vehiculos_lotes_terminados}],
                            bigcards:[{name:'Bultos xHa',value:item.bultos_cosechados_lotes_terminados/item.area_terminada}],
                            area:[{tipo:'Cosechada',cantidad:item.area_terminada,porcentaje:(item.area_terminada/item.area_total)*100},{tipo:'Sin cosechar',cantidad:item.area_total-item.area_terminada,porcentaje:((item.area_total-item.area_terminada)/item.area_total)*100}],
                            lotes:[{tipo:'Cosechados',cantidad:item.num_lotes,porcentaje:(item.nume_lotes_terminados/item.num_lotes)*100},{tipo:'Sin cosechar',cantidad:item.num_lotes-item.num_lotes_terminados,porcentaje:((item.num_lotes-item.num_lotes_terminados)/item.num_lotes)*100}]};
        return itemMod;
    };

    btnClick() {
        let proxy = this;
        let count = 8;
        let panel = [{
                'id': count.toString() + '_layout', 'sizeX': 1, 'sizeY': 1, 'row': 0, 'col': 0,
                content: '<span id="close" className="e-template-icon e-clear-icon"></span><div className="text-align">' + count.toString() + '</div>'
            }];
        count = count + 1;
        proxy.dashboardObj.addPanel(panel[0]);
    }
    load(args) {
        //debugger;
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.accumulation.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
        
    }
    Chartload(args) {
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.chart.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
        if (selectedTheme === 'highcontrast') {
            args.chart.series[0].marker.dataLabel.fill = '#000000';
            args.chart.series[1].marker.dataLabel.fill = '#000000';
        }
    }
    ;
    Mapload(args) {
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.maps.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
    }
    ;
    /* card1() {
        return (<div className="card">
                <span className="e-icons session"></span>
                <div className="card-content text">
                    Bultos Cosechados
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.bultos_cosechados,0,'.',',')}
                </div>
            </div>);
    }
    card2() {
        return (<div className="card">
            <span className="e-icons profile"></span>
            <div className="card-content text">
                Bultos Cosechados en lotes terminados
            </div>
            <div className="card-content number">
                {number_format(g_ind_cosecha.bultos_cosechados_lotes_terminados)}
            </div>
        </div>);
    }
    card3() {
        return (<div className="card">
                <span className="e-icons views"></span>
                <div className="card-content text">
                    Bultos Cargados
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.bultos_cargados)}
                </div>
            </div>);
    } 
    
     card4() {
        debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    'Bultos Cargados en Lotes terminados'
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.bultos_cargados_lotes_terminados,',','.')}
                </div>
            </div>);
    } */
    card1() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[0].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[0].value,',','.')}
                </div>
            </div>);
    }
    card2() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[1].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[1].value,',','.')}
                </div>
            </div>);
    }
    card3() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[2].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[2].value,',','.')}
                </div>
            </div>);
    }
    card4() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[3].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[3].value,',','.')}
                </div>
            </div>);
    }
    card5() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[4].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[4].value,',','.')}
                </div>
            </div>);
    }
    card6() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[5].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[5].value,',','.')}
                </div>
            </div>);
    }
    card7() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[6].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[6].value,',','.')}
                </div>
            </div>);
    }
    card8() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[7].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[7].value,',','.')}
                </div>
            </div>);
    }
    card9() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[8].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[8].value,',','.')}
                </div>
            </div>);
    }
    card10() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_ind_cosecha.cards[9].name}
                </div>
                <div className="card-content number">
                    {number_format(g_ind_cosecha.cards[9].value,',','.')}
                </div>
            </div>);
    }
    bigcard1() {
        //debugger;
        return (<div className="big-card">
                <div className="big-card-content text">
                    {g_ind_cosecha.bigcards[0].name}
                </div>
                <div className="big-card-content number">
                    {number_format(g_ind_cosecha.bigcards[0].value,',','.')}
                </div>
            </div>);
    }
    map() {
        return (<div style={{ height: "100%", width: "100%" }}>
        <MapsComponent id="maps" load={this.Mapload} zoomSettings={{
            enable: false
        }} legendSettings={{
            visible: false
        }}>
                        <Inject services={[Marker, MapsLegend, MapsTooltip]}/>
                        <LayersDirective>
                            <LayerDirective shapeData={new MapAjax('https://ej2.syncfusion.com/react/demos/src/dashboard-layout/world-map.json')} shapePropertyPath='continent' shapeDataPath='continent' dataSource={datasource.default} shapeSettings={{
                                    colorValuePath: 'color'}}>
                                                        <MarkersDirective>
                                                            <MarkerDirective visible={true} template='<div style="font-size: 12px;color:white;text-shadow: 0px 1px 1px black;font-weight: 500;width:50px">{{:name}}</div>' animationDuration={0} dataSource={markers}>
                                                            </MarkerDirective>
                                                            <MarkerDirective visible={true} shape='Image' imageUrl='./src/dashboard-layout/ballon.png' height={20} width={20} offset={{
                                    y: -10,
                                    x: 0}} 
                                    animationDuration={0} tooltipSettings={{
                                    visible: true,
                                    valuePath: 'name'}} 
                                    dataSource={[
                                    { latitude: 37.6276571, longitude: -122.4276688, name: 'San Bruno' },
                                    { latitude: 33.5302186, longitude: -117.7418381, name: 'Laguna Niguel' },
                                    { latitude: 40.7424509, longitude: -74.0081468, name: 'New York' },
                                    { latitude: -23.5268201, longitude: -46.6489927, name: 'Bom Retiro' },
                                    { latitude: 43.6533855, longitude: -79.3729994, name: 'Toronto' },
                                    { latitude: 48.8773406, longitude: 2.3299627, name: 'Paris' },
                                    { latitude: 52.4643089, longitude: 13.4107368, name: 'Berlin' },
                                    { latitude: 19.1555762, longitude: 72.8849595, name: 'Mumbai' },
                                    { latitude: 35.6628744, longitude: 139.7345469, name: 'Minato' },
                                    { latitude: 51.5326602, longitude: -0.1262422, name: 'London' }
                                ]}>
                                        </MarkerDirective>
                                </MarkersDirective>
                            </LayerDirective>
                        </LayersDirective>
                    </MapsComponent>
                </div>);
    }
/*     PivotGrafica() {
        return (<div style={{ height: "100%", width: "100%" }}>
              < PivotGrafica className='col'/>
            </div>); 
    }*/
    pie() {
        return (<div style={{ height: "100%", width: "100%" }}>
              <AccumulationChartComponent id='pie' legendSettings={{ visible: true }} enableSmartLabels={true} height="100%" width="100%" 
              // eslint-disable-next-line
              enableAnimation={false} selectionMode={"Point"} center={{ x: '50%', y: '50%' }} tooltip={{ enable: false, header: "<b>${point.x}</b>", format: 'Cantidad : <b>${point.y}</b>' }} 
              load={this.load.bind(this)}>
              <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel]}/>
              <AccumulationSeriesCollectionDirective>
                {/* <AccumulationSeriesDirective dataSource={expensedata} name='Revenue' xName='Device' yName='Amount' explode={false} dataLabel={{
                 */}
                 <AccumulationSeriesDirective dataSource={g_ind_cosecha.lotes} name='Revenue' xName='tipo' yName='cantidad' explode={false} dataLabel={{
                    visible: true,
                        position: 'Inside', name: 'Amount',
                        font: {
                            fontWeight: '600'
                        }
                    }} radius='100%' innerRadius='35%' palettes={['#357cd2', '#00bdae', '#e36593']}>
                {/* <AccumulationSeriesDirective dataSource={dataSourceDash} name='Revenue' xName='Lote' yName='Bultos' explode={false} dataLabel={{
                        visible: true,
                        position: 'Inside', name: 'text',
                        font: {
                            fontWeight: '600'
                        }
                    }} radius='100%' innerRadius='35%' palettes={['#357cd2', '#00bdae', '#e36593']}> */}
                </AccumulationSeriesDirective>
              </AccumulationSeriesCollectionDirective>
            </AccumulationChartComponent>
            </div>);
    }
    visitorsChart() {
        return (<div style={{ height: "100%", width: "100%" }}>
                <ChartComponent id='visitorsChart' style={{ textAlign: "center" }} load={this.Chartload.bind(this)} legendSettings={{ visible: false }} 
                primaryXAxis={{
                    valueType: 'DateTime',
                    labelFormat: 'y',
                    majorGridLines: { width: 0 },
                    intervalType: 'Years',
                    edgeLabelPlacement: 'Shift'
                }} primaryYAxis={{
                    labelFormat: '{value}',
                    lineStyle: { width: 0 },
                    maximum: 4, interval: 1,
                    majorTickLines: { width: 0 },
                    minorTickLines: { width: 0 }
                }} chartArea={{ border: { width: 0 } }}>
                        <Inject services={[SplineAreaSeries, DateTime, Legend]}/>
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={data1} xName='x' yName='y' name='Jan' opacity={0.5} type='SplineArea' width={2} fill="rgb(239, 183, 202)">
                            </SeriesDirective>X
                            <SeriesDirective dataSource={data2} xName='x' yName='y' name='Feb' opacity={0.5} type='SplineArea' width={2} fill="rgb(14, 64, 152, .6)">
                            </SeriesDirective>
                            {/* <SeriesDirective dataSource={dataSourceDash} xName='Fecha' yName='Bultos' name='Ordenes de Servicio' opacity={0.5} type='SplineArea' width={2} fill="rgb(239, 183, 202)">
                            </SeriesDirective>  */}
                        </SeriesCollectionDirective>
                    </ChartComponent>

            </div>); 
    }
    pieChart() {
        return (<div style={{ height: "90%", width: "90%" }}>
                 <AccumulationChartComponent id='pieChart' legendSettings={{ visible: false }} enableSmartLabels={true} height="100%" width="100%" 
                 // eslint-disable-next-line
                    enableAnimation={false} selectionMode={"Point"} center={{ x: '50%', y: '50%' }} tooltip={{ enable: true, header: "<b>${point.x}</b>", 
                    /* format: 'Cantidad : <b>${point.y}%</b>' }} load={this.load.bind(this)}> */
                    format: '<b></b>' }} load={this.load.bind(this)}>
                    <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel]}/>
                    <AccumulationSeriesCollectionDirective>
                    {/* AccumulationSeriesDirective dataSource={[
                        { 'x': 'Desktop', y: 37, text: '60%' }, { 'x': 'Mobile', y: 17, text: '10%' },
                        { 'x': 'Tablet', y: 19, text: '20%' } */}
                    <AccumulationSeriesDirective dataSource={g_ind_cosecha.area} xName='tipo' yName='porcentaje' explode={true} 
                    explodeIndex={2} explodeOffset={"10%"} dataLabel={{
                        visible: true,
                        position: 'Inside', name: 'cantidad',
                        font: {
                            fontWeight: '600',
                            format: '#0.00'
                        }
                        }} radius='90%'>
                    {/* <AccumulationSeriesDirective dataSource={this.data} 
                            xName='depto' yName='idordser' explode={true} explodeIndex={2} explodeOffset={"10%"} dataLabel={{
                            visible: true,
                            position: 'Inside', name: 'text',
                            font: {
                                fontWeight: '600'
                            }
                            }} radius='100%'> */}
                </AccumulationSeriesDirective>
              </AccumulationSeriesCollectionDirective>
            </AccumulationChartComponent>
            </div>);
    }
    colChart() {
        
        return (<div style={{ height: "100%", width: "100%" }}>
                  <ChartComponent id='colChart' style={{ textAlign: "center" }} load={this.Chartload.bind(this)} legendSettings={{ visible: false }} 
                  primaryXAxis={{ valueType: 'Category', interval: 1, majorGridLines: { width: 0 } }} 
                  primaryYAxis={{
                            majorGridLines: { width: 0 },
                            majorTickLines: { width: 0 }, lineStyle: { width: 0 }, labelStyle: { color: 'transparent' }
                        }} chartArea={{ border: { width: 0 } }} tooltip={{ enable: true }}>
                        <Inject services={[ColumnSeries, Legend, Tooltip, Category, DataLabel]}/>
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={[{ x: 'Jan', y: 46 }, { x: 'Feb', y: 27 }, { x: 'Mar', y: 26 }]} xName='x' yName='y' name='Desktop' type='Column' marker={{ dataLabel: { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }}>
                            </SeriesDirective>
                            <SeriesDirective dataSource={[{ x: 'Jan', y: 37 }, { x: 'Feb', y: 23 }, { x: 'Mar', y: 18 }]} xName='x' yName='y' name='Mobile' type='Column' marker={{ dataLabel: { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }} fill='#e56691'>
                            </SeriesDirective>
                            <SeriesDirective dataSource={[{ x: 'Jan', y: 38 }, { x: 'Feb', y: 17 }, { x: 'Mar', y: 26 }]} xName='x' yName='y' name='Tablet' type='Column' marker={{ dataLabel: { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }}>
                            </SeriesDirective>
                            {/* <SeriesDirective dataSource={dataSourceDash} xName='Lote' yName='Bultos' name='Tablet' animation={{ enable: false }} marker={{ dataLabel: { visible: true, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }}>
                            </SeriesDirective> */}
                        </SeriesCollectionDirective>
                    </ChartComponent>
            </div>);
    }
/*     pivotTemplate() {
              
        return (<div className="template">
            
            <PivotTableToolBar style={{ "height": "100%", "width": "100%" }} pv_id='PivotViewVentas' pts_id='pivot-table-section-ventas' dataSourceSettings={pivotDataSettings.ventas} opcion='ventas'  arch_json={true} />
        </div>);
    } */

    
    componentDidMount() {
        //this.data = await consultar(config.HostUrl + "analisis/resumen?cosecha=1",authenticationService.currentUserValue.jwt_token);
        //this.data = await this.consultar(config.HostUrl + "analisis/resumen?cosecha=1",authenticationService.currentUserValue.jwt_token);
        this.data = this.consultar(JSON.parse(sessionStorage.config).HostUrl + this.CfgOptions[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.CfgOptions[this.props.opcion].endpoint + "?cosecha=1",authenticationService.currentUserValue.jwt_token);
        /* this.maestroCosecha = new DataManager({
            url: config.HostUrl + "queries/cosecha",
            adaptor: new WebApiAdaptor,
            headers:[{ "Content-Type":  "application / json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`
                    }],
            crossDomain: true
        }); */
        //this.data = g_data
        //g_ind_cosecha = this.consulta_cosecha(this.data,1);

    }
    async consultar(url,token) {
        var fetchHeaders={};
    
        if (token) {
            fetchHeaders= { "Content-Type": "application/json", "api-token": `${token}` };
        } 
        var requestOptions = { 
            method: 'GET',
            //mode: 'no-cors',
            headers: fetchHeaders,
            redirect: 'follow'
        };
        const resp = await fetch( url, requestOptions)
        .then(handleResponse)
        .then(info => {
            this.setState({ data : info, loading : false });
            return info;
        })
        .catch(err => console.log('Error de consulta de datos.'+err) );
        

        return resp
    }

    render() {
        //debugger;
  /*       const override = `
                        display: block;
                        margin: 0 auto;
                        border-color: red;
                        `; */
        v_total=0;
        Object.keys(expensedata).forEach((key, index) => {
                v_total = v_total + parseFloat(expensedata[key].Amount); 
            });
        if (this.state.loading === true) {
            return (
                <div className="control-section" id="target_dash">
                    <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
            
                        <div id="analytic_head">
                            <div className="header">
                                
                                <div className="combo-content"> Resumen de Cosecha
                                            <ComboBoxComponent id="cosechas" dataSource={this.maestroCosecha} ref={(combobox) => { this.listObj = combobox; }} fields={this.fields} change={this.onChange.bind(this)} placeholder="Seleccione la cosecha" value={this.value} popupHeight="220px"/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            
            );
        }
        else {
            //debugger;
            
            g_ind_cosecha = this.consulta_cosechas(this.state.data,1);
            
        return (<div>
            <div className="control-section" id="target_dash">
                <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
            
                    <div id="analytic_head">
                        <div className="header">
                            <div className="combo-content"> Resumen de Cosecha
                                        <ComboBoxComponent id="cosechas" dataSource={this.maestroCosecha} ref={(combobox) => { this.listObj = combobox; }} fields={this.fields} change={this.onChange.bind(this)} placeholder="Seleccione la cosecha" value={this.value} popupHeight="220px"/>
                            </div>
                        </div>
                    </div>
                    
                <div id="analytic_target">
                    <div className="sidebar-content">
                        <div className="dashboardParent">
                            <DashboardLayoutComponent id="analytic_dashboard" cellAspectRatio={100 / 85} cellSpacing={this.cellSpacing} columns={13} >
                                <PanelsDirective>
                                
                                    <PanelDirective sizeX={3} sizeY={1} row={3} col={0} content={this.card1.bind(this)}></PanelDirective>
                                    <PanelDirective sizeX={3} sizeY={1} row={3} col={3} content={this.card2}></PanelDirective>
                                    <PanelDirective sizeX={3} sizeY={1} row={3} col={6} content={this.card3}></PanelDirective>
                                    <PanelDirective sizeX={3} sizeY={1} row={3} col={9} content={this.card4}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={0} content={this.card5}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={2} content={this.card6}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={4} content={this.card7}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={6} content={this.card8}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={8} content={this.card9}></PanelDirective>
                                    <PanelDirective sizeX={2} sizeY={1} row={4} col={10} content={this.card10}></PanelDirective>
                                    <PanelDirective sizeX={6} sizeY={3} row={0} col={6} content={this.bigcard1}></PanelDirective>
                                    {/* <PanelDirective sizeX={4} sizeY={5} row={1} col={0} content={this.map.bind(this)} header="<div>Regional Map</div>"></PanelDirective> */}
                                    <PanelDirective sizeX={3} sizeY={3} row={0} col={0} content={this.pieChart.bind(this)} header="<div>Area</div>"></PanelDirective>
                                    {/* <PanelDirective sizeX={8} sizeY={2} row={1} col={4} content={this.PivotGrafica.bind(this)} header="<div>Traffic History</div>"></PanelDirective> */}
                                    {/* <PanelDirective sizeX={8} sizeY={2} row={1} col={4} content={this.visitorsChart.bind(this)} header="<div>Traffic History</div>"></PanelDirective> */}
                                    <PanelDirective sizeX={3} sizeY={3} row={0} col={3} content={this.pie.bind(this)} header="<div>Lotes</div>"></PanelDirective>
                                    {/* <PanelDirective sizeX={7} sizeY={2} row={0} col={4} content={this.colChart.bind(this)} header="<div>Visitors by Type</div>"></PanelDirective> */}
                                    {/* <PanelDirective sizeX={5} sizeY={3} row={4} col={7} content={this.pieChart.bind(this)} header="<div>Useage Statistics</div>"></PanelDirective>
                                     */}
                                </PanelsDirective>
                            </DashboardLayoutComponent>
                        </div>
                    </div>
                </div>
                
            </div>
            </div>
        </div>);
    }
    }
}

